import axios from "./axios"

/**
 * 查詢服務類型配置
 * @param {*} businessType 
 */
const get = businessType => {
    return axios.get(`/public/api/v1/service-type-config?businessType=${businessType}`).then(res => res.data)
}

/**
 * 查詢服務類型配置詳情
 * @param {*} serviceType 
 */
const getDetails = serviceType => {
    return axios.get(`/public/api/v1/service-type-config/${serviceType}`).then(res => res.data)
}

/**
 * 根據服務類型獲取有效支付方式
 * @param {*} serviceType 
 * @returns 
 */
const getPayMethod = serviceType => {
    return axios.get(`/public/api/v1/service-type-config/pay-Method/${serviceType}`).then(res => res.data)
}

/**
 * 根據服務類型獲取領證地點
 * @param {*} serviceType 
 * @returns 
 */
const getZones = serviceType => {
    return axios.get(`/public/api/v1/service-type-config/zones/${serviceType}`).then(res => res.data)
}

export default {
    get,
    getDetails,
    getPayMethod,
    getZones
}